import { KeyboardTab } from "@mui/icons-material";
import { Typography, Button, Stack } from "@mui/material";
import { T } from "components/util/t";
import { Sx } from "utils/sx";

const drawerHeaderStyles: Sx = (theme) => ({
    boxShadow: theme.shadows.custom[1],
    backgroundColor: theme.palette.background.paper,
    zIndex: theme.zIndex.drawer + 1,
    padding: theme.spacing(2),
    minHeight: theme.spacing(9.75),
});

const hideButtonStyles: Sx = (theme) => ({
    minWidth: theme.spacing(12.5),
});

export const PendingLeaderboardDrawerHeader: React.FC<{
    closeDrawer: () => void;
}> = ({ closeDrawer }) => {
    return (
        <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={drawerHeaderStyles}
        >
            <Typography variant="h7" component="h2" sx={{ flexGrow: 1 }}>
                <T>Round rankings</T>
            </Typography>
            <Button
                sx={hideButtonStyles}
                onClick={closeDrawer}
                startIcon={<KeyboardTab />}
            >
                <T>Hide</T>
            </Button>
        </Stack>
    );
};
